export default __webpack_public_path__ + "static/media/expense_bg_left.7f01d1f7.png";